"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Package import
 */
const react_1 = __importDefault(require("react"));
const crumble_1 = require("@oclock/crumble");
/**
 * Local import
 */
const logo_svg_1 = __importDefault(require("../../../assets/images/logo.svg"));
/**
 * Component
 */
const Nav = () => (react_1.default.createElement(crumble_1.Menu, { logoUrl: logo_svg_1.default.toString(), items: [
        {
            href: '/',
            icon: 'ClipboardAlt',
            label: 'Les instances',
        }
    ] }));
exports.default = Nav;
